import script from "./MainModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MainModal.vue?vue&type=script&setup=true&lang=js"

import "./MainModal.vue?vue&type=style&index=0&id=14bc4e0a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14bc4e0a"]])

export default __exports__